<ng-template #content>
    <div
      [attr.aria-labelledby]="tabTitle"
      role="tabpanel"
      [hidden]="!active"
      [id]="tabTitle + 'panel'"
      class="pane">
      <ng-content></ng-content>
    </div>
  </ng-template>
  